import React, { useEffect,useState } from "react";
import { Modal } from "@themesberg/react-bootstrap";
import ImageGallery from "react-image-gallery";
import { getImagesFromParcelId } from "../../../parse-functions/images";
import { useDispatch } from "react-redux";
import { updateSpinnerState } from "../../../actions/spinner";

const PODImageSlider = (props) => {
    const {
        show,
        handleClose,
        images=[],
        description = "",objectId
    } = props;
    const [imagesArray,setImagesArray] = useState(images)
    const [typeImage,setTypeImage] = useState([])
    const dispatch = useDispatch()

    const handleCloseClick = () => {

        setTypeImage([])
        handleClose()

    }

    const fetchPodImage = async (objectId) => 
    {
        try{
            dispatch(updateSpinnerState(true))
            let imagesRes = await getImagesFromParcelId({objectId})
            let imgArray = []
            if(imagesRes?.length > 0)
            {
         imgArray =  imagesRes?.map((img) => ({ original: img, thumbnail: img, description }));
            }else{
         imgArray =  images?.map((img) => ({ original: img, thumbnail: img, description }));
            }
      setTypeImage(imgArray)
      dispatch(updateSpinnerState(false))
            
        }catch(error)
        {
      dispatch(updateSpinnerState(false))

     const imgArray =  images?.map((img) => ({ original: img, thumbnail: img, description }));
     setTypeImage(imgArray)


            console.log(error)
        }
    }
    useEffect(() => {
        // Only fetch when the modal is actually open AND we have a parcel id.
        // This slider is rendered once at page level; previously the effect fired
        // on every mount/update (even while hidden, with no selection), calling
        // getImagesFromParcelId with an undefined objectId — which the backend
        // rejects ("Please pass Trip Number"). Gate it so the API is not called
        // unless it can succeed.
        if (show && objectId && imagesArray?.length === 0) {
            fetchPodImage(objectId)
        }
    },[show, objectId, images, imagesArray])



    

    return (
        <Modal show={show} onHide={handleCloseClick} className="modal-tertiary pod-images-modal">
            <ImageGallery items={typeImage} />
        </Modal>
    )
}
export default PODImageSlider